import {
  HomeIcon,
  ProfileIcon,
  EmploymentIcon,
  AppraisalIcon,
  BagIcon,
  ScheduleIcon,
  RequestIcon,
  //RequestIcon,
} from "../../../components/UIElements/svgIcons";
import {
  PATH_DASHBOARD,
  PATH_EMPLOYMENT,
  PATH_JOBBOARD,
  PATH_PROFILE,
  PATH_REQUESTS,
} from "../../../routes/path";

const NavConfig = () => {
  const content = [
    {
      title: "Home",
      path: PATH_DASHBOARD.root,
      icon: <HomeIcon />,
    },
    {
      title: "Job Board",
      path: PATH_JOBBOARD.root,
      icon: <BagIcon />,
    },
    {
      title: "Employment",
      path: PATH_EMPLOYMENT.root,
      icon: <EmploymentIcon />,
    },
    {
      title: "Requests",
      path: PATH_REQUESTS.root,
      icon: <RequestIcon />,
    },
    {
      title: "Timesheet",
      path: "/timesheet",
      icon: <AppraisalIcon />,
    },
    // {
    //   title: "Financial",
    //   path: "/financial",
    //   icon: <FinancialIcon />,
    // },
    // {
    //   title: "Subscription plans",
    //   path: "/subscriptions",
    //   icon: <SubscriptionIcon />,
    // },
    {
      title: "Schedule",
      path: "/schedule",
      icon: <ScheduleIcon />,
    },
    {
      title: "Profile",
      path: PATH_PROFILE.root,
      icon: <ProfileIcon />,
    },
  ];

  return content;
};

export default NavConfig;
